import { Box, CircularProgress } from "@mui/material";
import { useEffect } from "react";
import { useAppDispatch } from "store/appHooks";

import { ROUTES } from "constants/routes";
import { logoutUserAction } from "slices/authReducers";
import { clearNotificationForUser } from "slices/notificationReducer";
import { clearLocalUserProfile } from "slices/userReducer";

const Logout = () => {
  const dispatch = useAppDispatch();


  useEffect(() => {
    const init = async () => {
      dispatch(clearNotificationForUser());
      dispatch(
        logoutUserAction({
          navigate: () => (window.location.href = ROUTES.HOME),
        })
      );

      dispatch(clearLocalUserProfile());
      
    };
    init();
  }, [dispatch]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      flexDirection="column"
    >
      <CircularProgress size={50} />
      Please wait...
    </Box>
  );
};

export default Logout;
